import React, { createContext, useContext, ReactNode, useMemo } from "react";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import type { SdeWorkbookClient } from "@services/clients/SdeWorkbookClient";
import { DefaultSdeWorkbookClient } from "@services/clients/DefaultSdeWorkbookClient";
import { StubSdeWorkbookClient } from "@services/stubs/StubSdeWorkbookClient";
import { enabledFeatures, FeaturesEnum } from "@utils/enabledFeatures";
import { requireContext } from "@contexts/requireContext";

const SdeWorkbookClientContext = createContext<OptionTs<SdeWorkbookClient>>(Option.none());

export const SdeWorkbookClientProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const sdeWorkbookClient = useMemo<SdeWorkbookClient>(() => {
        if (enabledFeatures[FeaturesEnum.StubClients]) {
            return new StubSdeWorkbookClient();
        }
        return new DefaultSdeWorkbookClient();
    }, []);

    const contextValue = useMemo(() => Option.some(sdeWorkbookClient), [sdeWorkbookClient]);

    return <SdeWorkbookClientContext.Provider value={contextValue}>{children}</SdeWorkbookClientContext.Provider>;
};

export const useSdeWorkbookClient = (): SdeWorkbookClient =>
    requireContext(useContext(SdeWorkbookClientContext), "useSdeWorkbookClient must be used within a SdeWorkbookClientProvider");
